namespace Areas.Employee.Web {
    "use strict";

    var webFormUpdate: UpdateOperations;

    $(() => { init(); });

    function init() {
        if ($("#EmployeeWebForm").dxForm("instance")) {
            webFormUpdate = new UpdateOperations("EmployeeWebForm", "/Employee/Web/Put");
        }
    }

    export function updateWebRecord(e: any) {
        webFormUpdate.updateRecord();
    }

}